export default __webpack_public_path__ + "static/media/flower-1.2582bee8.svg";